<mat-sidenav-container class="mainWrapper milinco-app-shell" autosize autoFocus (backdropClick)="closeOverlayNav()" [ngClass]="{
  'sidebarNav-mini': !options.horizontal && (isSidebarMini() || isDesktopRailOnly()) && !isPosImmersiveShell(),
  'sidebarNav-pos': isPosShell(),
  'sidebarNav-pos-immersive': isPosImmersiveShell(),
  'sidebarNav-pos-workspace': isEmbeddedPos(),
  'sidebarNav-horizontal': options.horizontal,
  'sidebarNav-mobile-dock': showMobileDock(),
  cardBorder: options.cardBorder,
  'layout-boxed': options.boxed,
  'layout-full-width': !options.boxed,
}" [dir]="options.dir!">
  <!-- ============================================================== -->
  <!-- Vertical Sidebar -->
  <!-- ============================================================== -->
  <!-- Con dock handset el rail+drawer overlay no se monta (nav primaria = dock). -->
  <!-- POS inmersivo (un módulo): sin rail — lienzo full bleed. -->
  @if (!options.horizontal && !showMobileDock() && !isPosImmersiveShell()) {
  <mat-sidenav #leftsidenav [mode]="isOver ? 'over' : 'side'" [disableClose]="false"
      [milincoOverlayNavDismiss]="isOver && mobileNavOpenUi"
      [rtl]="options.dir === 'rtl'"
      (overlayNavDismissed)="closeOverlayNav()"
      [opened]="
      options.navPos === 'side' && options.sidenavOpened && !isOver && !resView
    " (openedChange)="onSidenavOpenedChange($event)" (closedStart)="onSidenavClosedStart()" class="sidebarNav">
    @if (isOver) {
      <!-- Drawer desde la izquierda → asa en el borde interior (end). -->
      <app-milinco-sheet-handle placement="end" />
    }
    <ng-scrollbar class="relative" style="height: 100%">
      <div class="iconMenu">
        <app-iconmenu [menuItems]="railMenuItems" [navItemsForModule]="navItems"
          [selectedModuleId]="selectedIcon"
          [collapsed]="isSidebarMini() || isDesktopRailOnly()"
          [showExpandToggle]="isSidebarMini()"
          (toggleCollapsed)="toggleCollapsed()" (openClosedMenu)="openClosedMenu()"
          (iconSelected)="onIconSelected($event)"
          (posExitCompleted)="onPosExitCompleted()"></app-iconmenu>
      </div>
      @if (showInnerSidebar()) {
      <div class="flex-layout flex flex-col h-screen inner-sidebar">
        <app-sidebar
          (toggleMobileNav)="sidenav.toggle()"
          (toggleCollapsed)="toggleCollapsed()"
          [showToggle]="isOver"
          [showCollapseToggle]="!isOver && !isPosShell()"
        ></app-sidebar>
        @if (showModuleNavList()) {
        <ng-scrollbar class="relative sidebar-module-scroll" style="height: 100%">
          <mat-nav-list class="sidebar-list" #sidebarModuleList>
            @for(menus of navItems; track menus.id) { @if(selectedIcon===menus.id){
            @for(item of menus.children; track trackSidebarChild(item, $index)){
            <app-nav-item [item]="item" (notify)="sidenav.toggle()" class="top-parent">
            </app-nav-item>
            } } }
          </mat-nav-list>
        </ng-scrollbar>
        }
      </div>
      }
    </ng-scrollbar>
  </mat-sidenav>
  }

  <!-- ============================================================== -->
  <!-- horizontal Sidebar -->
  <!-- ============================================================== -->
  <!-- Horizontal: en escritorio top nav; en handset el dock sustituye este overlay. -->
  @if (options.horizontal && resView && !showMobileDock() && !isPosImmersiveShell()) {
  <mat-sidenav #leftsidenav [mode]="'over'" [disableClose]="false"
    [milincoOverlayNavDismiss]="mobileNavOpenUi"
    [rtl]="options.dir === 'rtl'"
    (overlayNavDismissed)="closeOverlayNav()"
    [opened]="options.sidenavOpened && !isTablet"
    (openedChange)="onSidenavOpenedChange($event)" (closedStart)="onSidenavClosedStart()" class="sidebarNav">
    <app-milinco-sheet-handle placement="end" />
    <div class="iconMenu">
    <app-iconmenu [menuItems]="railMenuItems" [navItemsForModule]="navItems"
        [selectedModuleId]="selectedIcon"
        [collapsed]="false"
        [showExpandToggle]="false"
        (toggleCollapsed)="toggleCollapsed()" (openClosedMenu)="openClosedMenu()"
        (iconSelected)="onIconSelected($event)"
        (posExitCompleted)="onPosExitCompleted()"></app-iconmenu>
    </div>
    @if (showInnerSidebar()) {
    <div class="flex-layout flex flex-col h-screen inner-sidebar">
      <app-sidebar
        (toggleMobileNav)="sidenav.toggle()"
        (toggleCollapsed)="toggleCollapsed()"
        [showToggle]="true"
        [showCollapseToggle]="false"
      ></app-sidebar>
      @if (showModuleNavList()) {
      <ng-scrollbar class="relative sidebar-module-scroll" style="height: 100%">
        <mat-nav-list class="sidebar-list" #sidebarModuleList>
          @for(menus of navItems; track menus.id) { @if(selectedIcon===menus.id){
          @for(item of menus.children; track trackSidebarChild(item, $index)){
          <app-nav-item [item]="item" (notify)="sidenav.toggle()">
          </app-nav-item>
          } } }
        </mat-nav-list>
      </ng-scrollbar>
      }
    </div>
    }
  </mat-sidenav>
  }

  <!-- ============================================================== -->
  <!-- Main Content -->
  <!-- ============================================================== -->
  <mat-sidenav-content class="contentWrapper" #content>
    <!-- ============================================================== -->
    <!-- VerticalHeader -->
    <!-- ============================================================== -->
    @if (!options.horizontal || showMobileDock()) {
    <app-header
      [showToggle]="isPosImmersiveShell() || !isOver || showMobileDock()"
      [sidenavCollapsed]="isSidebarMini()"
      [mobileNavOpen]="isOver && mobileNavOpenUi && !showMobileDock()"
      [posImmersive]="isPosImmersiveShell()"
      (toggleCollapsed)="toggleCollapsed()" (toggleMobileNav)="onToggleMobileNav()"
      (toggleMobileFilterNav)="filterNavRight.toggle()"
      (posExitCompleted)="onPosExitCompleted()"
    ></app-header>
    } @else {
    <!-- horizontal header (escritorio / tablet sin dock) -->
    <app-horizontal-header (toggleMobileNav)="sidenav.toggle()" (toggleMobileFilterNav)="filterNavRight.toggle()"></app-horizontal-header>
    }
    @if (options.horizontal && !showMobileDock()) {
    <app-horizontal-sidebar [navItems]="horizontalNavItems"></app-horizontal-sidebar>
    }
    <div
      class="body-wrapper"
      cdkScrollable
      [class.body-wrapper--pos]="isPosWorkspace()"
    >
      <main
        class="pageWrapper"
        [class.pageWrapper--pos]="isPosWorkspace()"
        [ngClass]="{
          maxWidth: options.boxed
        }"
      >
        <app-breadcrumb></app-breadcrumb>
        <!-- ============================================================== -->
        <!-- Outlet -->
        <!-- ============================================================== -->
        <router-outlet></router-outlet>
        @if (!isPosWorkspace()) {
          <div class="fixed bottom-7 right-7 rtl:right-auto rtl:left-7 z-10 admin-fab-safe">
            <button
              mat-fab
              type="button"
              class="admin-customizer-fab"
              (click)="customizerRight.toggle()"
              [attr.aria-label]="'layout.customizer.title' | translate"
            >
              <mat-icon>settings</mat-icon>
            </button>
          </div>
        }
      </main>
    </div>
  </mat-sidenav-content>

  <mat-sidenav #customizerRight mode="over" position="end" class="customizerNav">
    <div class="px-4 py-5 flex! items-center justify-between border-b border-border">
      <h3 class="text-xl font-semibold">{{ 'layout.customizer.title' | translate }}</h3>

      <a mat-icon-button (click)="customizerRight.toggle()" class="flex justify-center">
        <mat-icon>close</mat-icon>
      </a>
    </div>

    <app-customizer (optionsChange)="receiveOptions($event)"></app-customizer>
  </mat-sidenav>
</mat-sidenav-container>

<app-admin-utility-rail />

@if (showMobileDock()) {
  <app-milinco-mobile-dock
    [menuItems]="railMenuItems"
    [navItems]="navItems"
    [selectedModuleId]="selectedIcon"
    [posShell]="isPosShell()"
    (moduleSelected)="onIconSelected($event)"
    (posExitCompleted)="onPosExitCompleted()"
  />
}

<!-- ------------------------------------------------------------------
  Mobile Apps Sidebar
  ------------------------------------------------------------------ -->
<mat-drawer #filterNavRight mode="over" position="end" class="filter-sidebar">
  <div>
    <div class="flex justify-between items-center">
      <div class="branding">
        <app-branding></app-branding>
      </div>
      <button mat-icon-button (click)="filterNavRight.toggle()" class="flex justify-center">
        <i-tabler name="x" class="size-4.5! flex"></i-tabler>
      </button>
    </div>

    <mat-accordion>
      <mat-expansion-panel class="shadow-none!">
        <mat-expansion-panel-header>
          <mat-panel-title class="text-base font-medium"> Apps </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <div class="grid grid-cols-12 gap-6">
            @for(appdd of apps; track appdd.title) {
            <div class="col-span-12 text-hover-primary">
              <a [routerLink]="[appdd.link]" class="flex items-center no-underline gap-4">
                <span class="text-{{ appdd.color }} bg-light-{{ appdd.color }} rounded size-12! flex items-center justify-center">
                  <span class="iconify size-5!" [attr.data-icon]="appdd.icon"></span>
                </span>

                <div>
                  <h5 class="text-sm font-semibold m-0 hover-text">
                    {{ appdd.title }}
                  </h5>
                  <span class="text-xs text-muted">{{ appdd.subtitle }}</span>
                </div>
              </a>
            </div>
            }
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</mat-drawer>
